import lissen_logo_full from "@assets/logos/lissen_logo_full.svg";
import logo_round_large from "@assets/logos/logo_round_large.svg";
import premiumLogo from "@assets/logos/premiumLogo.svg";

const icons = {
  lissen_logo_full,
  logo_round_large,
  premiumLogo,
} as const;

export default icons;
